/**
 * index
 *
 * @Author  Yee
 * @DATE    create on 2019/6/26
 * @DESC    全局混入
 */
import SessionUtil from '../utils/SessionUtil'
import { mapGetters, mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['appName', 'user_info']),
        ...mapGetters({
            platform: 'platform'
        }),

        /**
         * 是否存在 sessionId
         * @returns {boolean}
         */
        isExistSessionId() {
            return !!SessionUtil.getAppEnvObject().sessionId
        },
        /**
         * 安卓
         * @return {boolean}
         */
        isAndroid() {
            return SessionUtil.getAppEnvObject().systemType === 'android'
        },
        /**
         * iPhone
         * @return {boolean}
         */
        isIos() {
            return SessionUtil.getAppEnvObject().systemType === 'ios'
        },
        /**
         * 微信小程序
         * @return {boolean}
         */
        isMiniProgram() {
            return SessionUtil.getAppEnvObject().clientType === 'wxmp'
        },

        /**
         * 获取用户信息
         * @returns
         */
        getUserInfo() {
            return this.$store.state.userInfo
        },

        /**
         * 用户是否登录
         * @returns {boolean}
         */
        isLogin() {
            return this.getUserInfo.isLogin
        },

        /**
         *
         *
         * 是否是微信小程序
         */
        isWechart() {
            return this.appName === 'VEHICLE_USER_AUTH_VEHICLE_WECHAT_MP'
        },

        /**
         *
         * 是否是QQ小程序
         * @returns
         */
        isQQ() {
            return this.platform === 'TENCENT_QQ_VEHICLE'
        },

        /**
         *
         * 是否是字节跳动小程序
         * @returns
         */
        isBytedance() {
            return this.platform === 'TENCENT_BYTE_DANCE_VEHICLE'
        },

        /**
         *
         * 是否是ios客户端
         * @returns
         */
        isIosApp() {
            return this.platform === 'IOS_VEHICLE'
        },
        /**
         *
         * 是否是android客户端
         * @returns
         */
        isAndroidApp() {
            return this.platform === 'ANDROID_VEHICLE'
        },
        /**
         * 是否是安全区机型
         */
        safeAreaInset() {
            const u = navigator.userAgent
            const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            if (isIOS && screen.height >= 812) {
                return true
            } else {
                return false
            }
        }
    }
}
